export const defaults = {
  colours: {
    tagline: "#ffffff",
    primary: {
      regular: "#43467F",
      dark: "#1C2260",
      darker: "#00044C",
    },
    secondary: {
      regular: "#47C1BF",
      dark: "#00848E", // 100% more saturated, 47% darker
      darker: "#003135", // 100% more saturated, 80% darker
      lighter: "#E0F5F5", // 77% brighter
    },
    tertiary: {
      light: "#DFE3E8",
      regular: "#DFE3E8",
      dark: "#C4CDD5",
    },
    red: {
      regular: "#330001",
      light: "#FBE9E5",
    },
    yellow: {
      darker: "#573A00",
      lighter: "#FBF1CD",
    },
    white: {
      regular: "#FFF",
      warm: "#FBEAE5",
    },
    text: {
      lightest: "#919eab",
      regular: "#454F5B",
      light: "#637381",
      nav: "#B3B5CB",
      emphasis: "#47C1BF",
    },
    util: {
      dark: "#212B36",
      background: "#41457C",
      link: "#54938B",
      sky: {
        regular: "#DFE3E8",
        dark: "#C4CDD5",
      },
      toast: {
        success: "#154246",
        error: "#5A302F",
        shadow: "#B7ECEC",
      },
      tableHover: "#ffffff",
      textAreaFocus: "#36B5AC",
    },
  },
  fonts: {
    primaryHeading: "DM-Serif-Display",
    secondaryHeading: "Assistant",
    generalContent: "Assistant",
  },
  text: {
    loginScreenDescription: "Providing home and homeowner wellness",
    walkthroughSignatureTermsAndConditions:
      "By signing this document, I acknowledge that I have completed the walkthrough and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.",
    homeOwnerWalkthroughSignatureTermsAndConditions:
      "By signing this document, I acknowledge that I have completed the homeowner orientation and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.",
    userActivationMessage:
      "Welcome to Juniper, you have successfully activated your account! Please create your password below.",
    serviceRequest: "Service Request",
    suite: "Suite",
    keyPickupConfirmation:
      "I acknowledge that I've received the necessary number of keys as stated in my homeowner care account for my home and communal spaces. I acknowledge that I have received all information for access to my home and homeowner care account and confirm the information shared with me is understood and accurate.",
    serviceRequestConfirmationHeader: "We're on it!",
    serviceRequestConfirmationBody:
      "Thank you for submitting a service request. \nWe respond to all inquiries in the order they are received and will do our best to resolve any concerns you may have.\nPlease allow up to 3 business days for a reply. \n\nFor any emergencies or urgent matters, please follow the instructions noted in your homeowner manuals.",
    messageConfirmationBody:
      "Your message has been sent. You will receive an email notification when a reply is posted.",
    homeOwner: 'Home Owner',
    noMessages: 'No messages'
  },
  images: {
    signInBackground: "/assets/sign-in.png",
    logo: {
      login: "/assets/logo-juniper-color@2x.png",
      mainApplication: "/assets/logo-white.svg",
    },
  },
};
